import React from "react";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  ConcludeContainer,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function ConelWeb() {
  const ProjectBG = require("../../../../assets/videos/conel-web/poster.png");
  const T1 = require("../../../../assets/videos/conel-web/t1.png");
  const T2 = require("../../../../assets/videos/conel-web/t2.png");

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="ConelWeb — 3D modeling meets the browser"
      lead={
        <p>
          A web showcase for Conel products: Blender-prepared 3D assets and an
          interactive experience built for the browser—no plugins required.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/conel-web/1_conel+web.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Enhancing user experience</WorkSectionHeading>
          <p>
            Products become explorable 3D models so users grasp dimensions,
            details, and form in a dynamic, intuitive way.
          </p>
          <WorkSectionHeading>Seamless web integration</WorkSectionHeading>
          <p>
            Users interact directly in the browser—reducing friction compared to
            desktop-only viewers or installs.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <video controls poster={T2}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/conel-web/2_conel+web.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Dimensions & information points</WorkSectionHeading>
          <p>
            Inspect size and proportions, and open placed info points for
            specifications and feature highlights.
          </p>
          <WorkSectionHeading>Engaging showcase</WorkSectionHeading>
          <p>
            The experience is designed to inform purchasing decisions through
            memorable, hands-on exploration.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <ConcludeContainer>
        <p>
          ConelWeb demonstrates how 3D and web development together can elevate
          product presentation and understanding.
        </p>
      </ConcludeContainer>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "Conel Web" },
          { label: "Period", value: "07.2021 - 01.2022" },
          { label: "Client", value: "Conel" },
          { label: "Engine & Tools", value: "Three js, Blender" },
          { label: "Platform", value: "Web" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "Web, 3D Modelling" },
        ]}
      />
    </WorkProjectShell>
  );
}
